module.exports = __webpack_public_path__ + "static/media/house.b306e1be.svg";